import { Box, Button } from '@mui/material';
import React from 'react';

interface CheckpointStatusResponseProps {
	statuses: PatrolCheckpointStatus[];
	selectedStatusID: number | null;
	onStatusClick: (selectedStatusID: number) => void;
}

const CheckpointStatusResponse: React.FC<CheckpointStatusResponseProps> = (
	props,
) => {
	// Implement your component logic here
	const { statuses, selectedStatusID, onStatusClick } = props;

	const getColor = (number: number) => {
		if (number === 1) return 'success';
		if (number === 2) return 'warning';
		if (number === 3) return 'error';
		return 'info';
	};
	return (
		<Box
			sx={{
				display: 'flex',
				gap: '0.5rem',
				mb: 1.5,
			}}
		>
			{statuses
				.filter((s) => s.isEnabled)
				.map((status) => (
					<Button
						key={status.StatusID}
						onClick={() => onStatusClick(status.StatusID)}
						variant={
							status.StatusID === selectedStatusID
								? 'contained'
								: 'outlined'
						}
						color={getColor(status.StatusNumber)}
					>
						{status.Name}
					</Button>
				))}
		</Box>
	);
};

export default CheckpointStatusResponse;
